import React from 'react';
import { motion } from 'framer-motion';
import { ScissorsIcon, HeartPulseIcon, SparklesIcon, SmileIcon, DumbbellIcon, UserIcon } from 'lucide-react';
const businessTypes = [{
  name: 'Barberías',
  icon: ScissorsIcon
}, {
  name: 'Clínicas',
  icon: HeartPulseIcon
}, {
  name: 'Estética',
  icon: SparklesIcon
}, {
  name: 'Dentistas',
  icon: SmileIcon
}, {
  name: 'Gimnasios',
  icon: DumbbellIcon
}, {
  name: 'Entrenadores',
  icon: UserIcon
}];
export function BusinessTypesSection() {
  return <section className="py-16 bg-light" data-id="element-14">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-15">
        <motion.h2 className="text-2xl md:text-3xl font-bold text-text mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-16">
          Perfecto para negocios como:
        </motion.h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6" data-id="element-17">
          {businessTypes.map((type, index) => <motion.div key={type.name} className="flex flex-col items-center gap-3 bg-white p-5 rounded-2xl border border-gray-100 shadow-sm" initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.07
        }} data-id="element-18">
              <type.icon className="w-7 h-7 text-primary" data-id="element-19" />
              <span className="text-sm font-medium text-text" data-id="element-20">{type.name}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}